import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/Establecimientos/establecimientos';
import Establecimiento from './establecimiento';


const ms2p = (state) => {
  return {
    ...state.establecimientos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Establecimiento);